import ReorderIcon from 'app/common/icons/reorder.svg';

import styles from './KitItem.module.scss';



interface Props {
  id: number
  title: string
}

export const KitItem = ({
  id,
  title,
}: Props) => {
  return (
    <div className={styles.container} >
      <span className={styles.title}>{title}</span>
      <ReorderIcon className={styles.reorder} />
    </div>
  );
};

